const TOUR_KEY = 'createEventTourState'

export const TOUR_STEPS = [
  { key: 'basicInfo', placement: 'bottom', title: 'Click to edit your Event ' },
  { key: 'guestList', placement: 'right', title: 'Click to build your Guest List' },
  { key: 'addGuests', placement: 'bottom', title: 'You can also Upload File to add Guests in bulk' }
]

export function getTourState() {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return {
      isSkipped: false,
      isBasicInfoTourOpened: false,
      isGuestListTourOpened: false,
      isAddGuestsTourOpened: false
    }
  }
  try {
    const data = JSON.parse(window.localStorage.getItem(TOUR_KEY))
    if (data && typeof data === 'object') {
      return {
        isSkipped: !!data.isSkipped,
        isBasicInfoTourOpened: !!data.isBasicInfoTourOpened,
        isGuestListTourOpened: !!data.isGuestListTourOpened,
        isAddGuestsTourOpened: !!data.isAddGuestsTourOpened
      }
    }
  } catch (e) {
    // ignore
  }
  return {
    isSkipped: false,
    isBasicInfoTourOpened: false,
    isGuestListTourOpened: false,
    isAddGuestsTourOpened: false
  }
}

export function setTourFlag(flagName, value) {
  const state = getTourState()
  state[flagName] = value
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return
  }
  window.localStorage.setItem(TOUR_KEY, JSON.stringify(state))
}

export function setTourSkip(value = true) {
  const state = getTourState()
  state.isSkipped = value
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return
  }
  window.localStorage.setItem(TOUR_KEY, JSON.stringify(state))
}

export function clearTourState() {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return
  }
  window.localStorage.removeItem(TOUR_KEY)
}
